<section>
  <div class="body-container">
    <section class="header" formEnhance>
      <div class="l-flex l-flex-wrap t-panel l-align-y">
        <input-wrap [loading]="clinicList().loading">
          <p-select
            #hasSearchDropdown
            [options]="clinicList()"
            optionLabel="label"
            [(ngModel)]="selectedClinic"
            [filterPlaceholder]="'translate.general.search' | translate"
            [placeholder]="'translate.general.clinic' | translate"
            [filter]="true"
            [resetFilterOnHide]="true"
            name="selectedClinic"
            (onChange)="search()"
            [virtualScroll]="true"
            [virtualScrollItemSize]="30"
            appendTo="body"
          >
          </p-select>
          <clear-multi
            *ngIf="selectedClinic"
            (click)="selectedClinic = null; search()"
          ></clear-multi>
        </input-wrap>

        <span class="spacer t-space--small"></span>
        <input-wrap [loading]="taskUsersList().loading">
          <p-select
            #hasSearchDropdown
            [options]="taskUsersList()"
            optionLabel="label"
            [(ngModel)]="selectedUser"
            [filterPlaceholder]="'translate.general.search' | translate"
            [placeholder]="'translate.general.taskUser' | translate"
            [filter]="true"
            [resetFilterOnHide]="true"
            name="selectedUser"
            (onChange)="search()"
          >
          </p-select>
          <clear-multi
            *ngIf="selectedUser"
            (click)="selectedUser = null; search()"
          ></clear-multi>
        </input-wrap>

        <span class="spacer t-space--med"></span>
        <button class="t-button t-button--flat" (click)="search()">
          {{ "translate.general.search" | translate }}
        </button>
        <span class="spacer t-space--small"></span>
        <button class="t-button-outline c-c1" (click)="clearSearch()">
          {{ "translate.general.clearFilter" | translate }}
        </button>
      </div>

      <button
        *ngIf="allowedCreateTask"
        (click)="createTask()"
        class="t-button-outline"
      >
        {{ "translate.agentTasks.createNew" | translate }}
      </button>
    </section>

    <div class="tasks-container">
      <section>
        <h2 class="t-widgetAccentTitle">
          {{ "translate.agentTasks.hist" | translate }}
        </h2>

        <div
          *ngIf="data && data.length == 0 && !loading"
          role="alert"
          class="c-alert t-alert-info"
        >
          {{ "translate.alert.noResults" | translate }}
        </div>

        <loader *ngIf="loading"></loader>

        <ui-table
          *ngIf="data && data.length"
          [isWrapped]="false"
          [data]="data"
          [dense]="false"
          [tblRoundBottom]="true"
          [numberOfRows]="numberOfRows"
          [totalRecords]="searchMetaData.totalRecords"
          (requestUpdate)="loadDataOnPagination($event)"
          [paginatorPosition]="'bottom'"
          [displayFilter]="displayColumnsList"
          (onRowSelect)="onRowSelect($event)"
        ></ui-table>
      </section>
    </div>
  </div>
</section>

<modal-popup
  [flexible]="true"
  [hideHeader]="true"
  (onClose)="displayEditTask = false"
  [isOpen]="displayEditTask"
>
  <edit-agent-task
    *ngIf="displayEditTask"
    [task]="curTask"
    (onCancel)="displayEditTask = false"
    (onSave)="onSave()"
  ></edit-agent-task>
</modal-popup>
